import * as React from "react";
import KnowladgeEffectiveCommunication from "../containers/KnowladgeEffectiveCommunication";

export default (props) => <KnowladgeEffectiveCommunication {...props} />;
